import createRoutine from '@/utils/createRoutine'

export const currentFundingReasonFormNameRoutine = createRoutine('currentFundingReasonFormNameRoutine')
export const fundingAmountRoutine = createRoutine('fundingAmountRoutine')
export const currentFundingReasonFormVersionRoutine = createRoutine('currentFundingReasonFormVersionRoutine')

export const currentFundingReasonFormNameGetters = {
  CURRENT_FORM_NAME: 'CURRENT_FORM_NAME'
}

export const currentFundingReasonFormVersionGetters = {
  CURRENT_FORM_VERSION: 'CURRENT_FORM_VERSION'
}

export const fundingAmountGetters = {
  FUNDING_AMOUNT: 'FUNDING_AMOUNT'
}

export const CURRENT_FORM_NAME_CLEANUP = 'CURRENT_FORM_NAME_CLEANUP'
export const FUNDING_AMOUNT_CLEANUP = 'FUNDING_AMOUNT_CLEANUP'
